import NTopNBottom from "../../components/NTopNBottom";

import navColor from "../../assets/xxinyun/nav/color.jpg";
import navBg from "../../assets/xxinyun/nav/nav_bg.png";
import navBgFixed from '../../assets/xxinyun/nav/nav_bg_fixed.png'

import far1 from "../../assets/xxinyun/nav/far1.png";
import far1_active from "../../assets/xxinyun/nav/far1_active.png";
import far2 from "../../assets/xxinyun/nav/far2.png";
import far2_active from "../../assets/xxinyun/nav/far2_active.png";
import son1 from "../../assets/xxinyun/nav/son1.png";
import son1_active from "../../assets/xxinyun/nav/son1_active.png";
import son2 from "../../assets/xxinyun/nav/son2.png";
import son2_active from "../../assets/xxinyun/nav/son2_active.png";
import son3 from "../../assets/xxinyun/nav/son3.png";
import son3_active from "../../assets/xxinyun/nav/son3_active.png";
import son4 from "../../assets/xxinyun/nav/son4.png";
import son4_active from "../../assets/xxinyun/nav/son4_active.png";
import son5 from "../../assets/xxinyun/nav/son5.png";
import son5_active from "../../assets/xxinyun/nav/son5_active.png";
import son6 from "../../assets/xxinyun/nav/son6.png";
import son6_active from "../../assets/xxinyun/nav/son6_active.png";
import son7 from "../../assets/xxinyun/nav/son7.png";
import son7_active from "../../assets/xxinyun/nav/son7_active.png";
import son8 from "../../assets/xxinyun/nav/son8.png";
import son8_active from "../../assets/xxinyun/nav/son8_active.png";
import son9 from "../../assets/xxinyun/nav/son9.png";
import son9_active from "../../assets/xxinyun/nav/son9_active.png";
import son10 from "../../assets/xxinyun/nav/son10.png";
import son10_active from "../../assets/xxinyun/nav/son10_active.png";
import bannerImg from "../../assets/xxinyun/banner.jpg";

import p1_1 from "../../assets/xxinyun/ctn/1_1.jpg";
import p1_2 from "../../assets/xxinyun/ctn/1_2.jpg";
import p1_3 from "../../assets/xxinyun/ctn/1_3.jpg";
import p2_1 from "../../assets/xxinyun/ctn/2_1.jpg";
import p2_2 from "../../assets/xxinyun/ctn/2_2.jpg";
import p2_3 from "../../assets/xxinyun/ctn/2_3.jpg";
import p3_1 from "../../assets/xxinyun/ctn/3_1.jpg";
import p3_2 from "../../assets/xxinyun/ctn/3_2.jpg";
import p4_1 from "../../assets/xxinyun/ctn/4_1.jpg";
import p4_2 from "../../assets/xxinyun/ctn/4_2.jpg";
import p5_1 from "../../assets/xxinyun/ctn/5_1.jpg";
import p5_2 from "../../assets/xxinyun/ctn/5_2.jpg";
import p6_1 from "../../assets/xxinyun/ctn/6_1.jpg";
import p6_2 from "../../assets/xxinyun/ctn/6_2.jpg";
import p7_1 from "../../assets/xxinyun/ctn/7_1.jpg";
import p7_2 from "../../assets/xxinyun/ctn/7_2.jpg";
import p7_3 from "../../assets/xxinyun/ctn/7_3.jpg";
import p8_1 from "../../assets/xxinyun/ctn/8_1.jpg";
import p8_2 from "../../assets/xxinyun/ctn/8_2.jpg";
import p9_1 from "../../assets/xxinyun/ctn/9_1.jpg";
import p9_2 from "../../assets/xxinyun/ctn/9_2.jpg";
import p10_1 from "../../assets/xxinyun/ctn/10_1.jpg";
import p10_2 from "../../assets/xxinyun/ctn/10_2.jpg";

import calcRemFn from "../calcRem";

const navCss = {
  navWrap: {
    minHeight: calcRemFn(175),
    backgroundImage: `url(${navColor})`
  },
  navCtn: {
    height: calcRemFn(175),
    backgroundImage: `url(${navBg})`
  },
  navCtnFixed: {
    height: calcRemFn(175),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    width: `${calcRemFn(90)}`,
    padding: `${calcRemFn(60)} 0 0 ${calcRemFn(16)}`,
    flexWrap: "wrap"
  },
  topBtnBaseCss: {
    width: calcRemFn(87),
    height: calcRemFn(28.5)
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(60)} 0 0 0`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(44),
    height: calcRemFn(70),
    padding: `0 ${calcRemFn(1)}`
  },
};

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: "top1",
      show: true,
      img: far1,
      img_actived: far1_active
    },
    {
      key: "top2",
      show: true,
      img: far2,
      img_actived: far2_active
    }
  ],
  bottom: {
    top1: [
      {
        key: "_i1",
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: 105217
      },
      {
        key: "_i2",
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: 105217
      },
      {
        key: "_i3",
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: 105217
      },
      {
        key: "_i4",
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: 105217
      },
      {
        key: "_i5",
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: 105217
      }
    ],
    top2: [
      {
        key: "_i1",
        show: true,
        img: son6,
        img_actived: son6_active,
        prodId: 105216
      },
      {
        key: "_i2",
        show: true,
        img: son7,
        img_actived: son7_active,
        prodId: 105216
      },
      {
        key: "_i3",
        show: true,
        img: son8,
        img_actived: son8_active,
        prodId: 105216
      },
      {
        key: "_i4",
        show: true,
        img: son9,
        img_actived: son9_active,
        prodId: 105216
      },
      {
        key: "_i5",
        show: true,
        img: son10,
        img_actived: son10_active,
        prodId: 105216
      }
    ]
  }
};

const pictures = [
  {
    id: 105217,
    type: "blue",
    ref: "top1_i1",
    farName: "top1",
    sonName: "_i1",
    son: [p1_1, p1_2, p1_3]
  },
  {
    id: 105217,
    type: "blue",
    ref: "top1_i2",
    farName: "top1",
    sonName: "_i2",
    son: [p2_1, p2_2, p2_3]
  },
  {
    id: 105217,
    type: "blue",
    ref: "top1_i3",
    farName: "top1",
    sonName: "_i3",
    son: [p3_1, p3_2]
  },
  {
    id: 105217,
    type: "blue",
    ref: "top1_i4",
    farName: "top1",
    sonName: "_i4",
    son: [p4_1, p4_2]
  },
  {
    id: 105217,
    type: "blue",
    ref: "top1_i5",
    farName: "top1",
    sonName: "_i5",
    son: [p5_1, p5_2]
  },
  {
    id: 105216,
    type: "blue",
    ref: "top2_i1",
    farName: "top2",
    sonName: "_i1",
    son: [p6_1, p6_2]
  },
  {
    id: 105216,
    type: "blue",
    ref: "top2_i2",
    farName: "top2",
    sonName: "_i2",
    son: [p7_1, p7_2, p7_3]
  },
  {
    id: 105216,
    type: "blue",
    ref: "top2_i3",
    farName: "top2",
    sonName: "_i3",
    son: [p8_1, p8_2]
  },
  {
    id: 105216,
    type: "blue",
    ref: "top2_i4",
    farName: "top2",
    sonName: "_i4",
    son: [p9_1, p9_2]
  },
  {
    id: 105216,
    type: "blue",
    ref: "top2_i5",
    farName: "top2",
    sonName: "_i5",
    son: [p10_1, p10_2]
  }
];

const topDiff = {
  firstSon: "_i1",
  top1_i1: 10,
  // top1_i2: 3,
  // top1_i3: -10,
  // top1_i4: -6,
  // top1_i5: -5,
  // top2_i1: 0,
  // top2_i2: 1,
  // top2_i3: -12,
  // top2_i4: -8
};

export default {
  title: "小幸孕",
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
};
